import logo from '../ImgComponents/analysis2.png'
export const AppHeader = () => (
  <>
    <header className='App-header d-flex'>
      <h6  className="d-flex">
        <img src={logo} className="App-logo  d-flex" alt="logo" />
        <div className="d-flex">
        T e x t r o n
        <p className="App_version">Version 2.5</p>
        </div>
      </h6>

    </header>
  </>
) 